import moment from "moment";
import ReactTable from 'react-table-6';
import Modal from '@mui/material/Modal';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { MODULE_TYPE } from "../../../constants/modal";
import { useState, useEffect, Fragment, useRef } from "react";
import { getRequest, postRequest, showMessage } from '../../../config';

import Tab from '@mui/material/Tab';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Add } from "@mui/icons-material";
import TabContext from '@mui/lab/TabContext';
import FormControl from '@mui/material/FormControl';
import { TablePagination, Typography } from '@mui/material'

import ChatGPTTab from './ChatGPTTab';
import AiTestComponent from './AiTest';
import ViewFirms from "./VCFirms/ViewFirms";
import AiHistoryComponent from './AiHistory';
import AiTwoHundredsComponent from './AiTwoHundreds';
import AiDeduperTestComponent from './AiDeduperTest';
import AiChecklistHistory from "./AiChecklistHistory";
import AddEditInvestor from "./VCFirms/AddEditInvestor";
import ChecklistBuilderComponent from './ChecklistModule';
import AiDeduperHistoryComponent from "./AiDeduperHistory";
import AiTwoMinTestHistoryComponent from './AiTwoMinTestHistory';
import AiTwoHundredsHistoryComponent from './AiTwoHundredsHistory';

import AiChecklist from "./AiChecklist";
import AnimatedPage from "../../../components/AnimatedPage";
import { toggleModal } from "../../../reducers/modalReducer";
import AiFilingAssistantTestComponent from "./AiFilingAssistantTest";
import AiFilingAssistantHistoryComponent from "./AiFilingAssistantHistory";
import HeadingSubheadingContent from "../../../components/HeadingSubheadingContent";

import DeleteSection from "../../../components/modals/section/DeleteSection";
import DeleteCategory from "../../../components/modals/category/DeleteCategory";
import CreateCategory from "../../../components/modals/category/CreateEditCategory";
import CreateEditSection from "../../../components/modals/section/CreateEditSection";
import CategoryLogsModal from "../../../components/modals/category/CategoryLogsModal";
import UserAllocationManagement from "../../../components/admin/AllocationManagement/UserAllocationManagement";
import { useLocation } from 'react-router-dom';
import TransactionSettings from "./TransactionSettings/index.jsx";
import SubscribedCompaniesTab from "./SubscribedCompaniesTab/index.js";
import AIPrompts from "./AIPrompts.js";


export default function Admin() {

	const dispatch = useDispatch();
	const location = useLocation();
	const modal = useSelector(state => state.modal);
	const subscribedCompanies = useRef([]);

	let [allUsers, setAllUsers] = useState([]);
	let [category, setCategory] = useState('');
	let [panel, setPanel] = useState('Modules');
	let [action, setAction] = useState('create');
	let [deleteFile, setDeleteFile] = useState();
	let [deleteUser, setDeleteUser] = useState();
	let [sectionNo, setSectionNo] = useState('');
	let [moduleList, setModuleList] = useState([]);
	let [moduleName, setModuleName] = useState('');
	let [allPartners, setAllPartners] = useState([]);
	let [sectionList, setSectionList] = useState([]);
	let [sectionName, setSectionName] = useState('');
	let [selectedFirm, setSelectedFirm] = useState();
	let [deleteCompany, setDeleteCompany] = useState();
	let [categoryList, setCategoryList] = useState([]);
	let [currentSection, setCurrentSection] = useState();
	let [selectedData, setSelectedData] = useState(null);
	let [archivedCompanies, setArchivedCompanies] = useState([]);
	let [subPanel, setSubPanel] = useState('Subscribed Companies');
	let [usersSubPanel, setUsersSubPanel] = useState('Users');
	let [superUserFilter, setSuperUserFilter] = useState('All');
	let [superUserOptions, setSuperUserOptions] = useState([]);
	let [deleteFileQuestionId, setDeleteFileQuestionId] = useState();
	let [aiTest, setAiTest] = useState(location.hash.includes('#AI'));
	let [partner, setPartner] = useState({ name: '', type: 'Business for Funding', testType: 'exit', moduleName: '', moduleKey: '', moduleDescription: '', focusArea: { focus1: '', focus2: '', focus3: '' } });

	//Pagigantion 
	let [currentPage, setCurrentPage] = useState(0);
	let [rowsPerPage, setRowsPerPage] = useState(10);
	let [deleteModuleName, setDeleteModuleName] = useState('');
	let [expensionPackList, setExpensionPackList] = useState([]);
	let [deletedCompaniesLogs, setDeletedCompaniesLogs] = useState([]);
	let [sectionsAndQuestions, setSectionsAndQuestions] = useState({});
	let [tabsAndKeysForChecklist, setTabsAndKeysForChecklist] = useState([]);
	let [tab, setTab] = useState(location.hash.replace("#", "").replace(/_/g, " ").replace("AI ", ""));

	const handleRevenueLeadMode = async (selectedData, data, type) => {
		try {
			const path = type === "company" ? `/company/updatecompany/${selectedData?._id}` : `/user/updateuser/${selectedData?._id}`
			const response = await postRequest(path, data)
			if (response['code'] === 200) {
				showMessage(response['message'])
				const newArr = allUsers.reduce((acc, current) => {
					if (current._id === selectedData?._id) current = { ...current, ...data }
					acc.push(current)
					return acc
				}, [])
				setAllUsers(newArr)
			}

		} catch (err) {
			console.log(err)
		} finally {
			// setIsLoading(false)
		}
	};


	const ActionColumn = ({ onDeleteClick, onEditClick, props }) => {
		return (
			<span className='number df jcc'>
				<button style={{ backgroundColor: "transparent" }}><i data-tooltip={`Edit  ${subPanel.replace("Management", "").trim()}`} style={{ color: props?.original?.isDefault ? '#E6E6E6' : '#fc7785 ', fontSize: '20px', cursor: props?.original?.isDefault ? "not-allowed" : 'pointer' }} className={`fa fa-pencil`} onClick={onEditClick} /></button>
				<button style={{ backgroundColor: "transparent" }}>
					<i data-tooltip={`Delete  ${subPanel.replace("Management", "").trim()}`} className="fa fa-trash c9 cp" style={{ fontSize: '20px', color: props?.original?.isDefault ? '#E6E6E6' : '#fc7785 ', cursor: props?.original?.isDefault ? "not-allowed" : 'pointer' }} onClick={onDeleteClick} /></button>
			</span >
		)
	};

	// Category Table Columns
	const CATEGORY_TABLE_COLUMNS = [
		{ id: 'name', Header: <div className="df jcs">Category Name</div>, Cell: props => (<div className="df jcs">{props?.original?.name}</div>) },
		{
			Header: <div className="df jcc">Action</div>,
			Cell: props => (
				<ActionColumn
					onDeleteClick={() => { if (!props?.original?.isDefault) { dispatch(toggleModal({ open: 'deleteModal' })); setSelectedData({ title: 'Category', ...props?.original, identifier: MODULE_TYPE.CATEGORY }) } }}
					onEditClick={() => { if (!props?.original?.isDefault) { dispatch(toggleModal({ open: 'addEditCategory' })); setSelectedData({ title: 'Edit Category', ...props?.original }); setCategory(props?.original?.name) } }}
					props={props}
				/>
			)
		},
	];

	// Section Table Columns
	const SECTION_TABLE_COLUMNS = [
		{ id: 'sectionNo', Header: <div className="df jcs">Section No</div>, Cell: props => (<div className="fw600 df jcs">{props?.original?.sectionNo}</div>) },
		{ id: "sectionName", Header: <div className="df jcs">Section Name</div>, Cell: props => (<div className="df jcs">{props?.original?.sectionName}</div>) },
		{
			Header: <div className="df jcc">Action</div>,
			Cell: props => (
				<ActionColumn
					onDeleteClick={() => { if (!props?.original?.isDefault) { dispatch(toggleModal({ open: 'deleteSection' })); setSelectedData({ title: 'Section', ...props?.original, name: props?.original?.sectionName, identifier: MODULE_TYPE.SECTION }) } }}
					onEditClick={() => { if (!props?.original?.isDefault) { dispatch(toggleModal({ open: 'addEditSection' })); setSelectedData({ title: 'Edit Section', ...props?.original }); setSectionNo(props?.original?.sectionNo); setSectionName(props?.original?.sectionName) } }}
					props={props}
				/>
			)
		},
	];

	// Module Table Columns
	const MODULE_TABLE_COLUMNS = [
		{ id: 'moduleName', Header: <div className="df jcs">Module Name</div>, Cell: props => (<div className="df jcs">{props?.original?.moduleName}</div>) },
		{
			Header: 'Action',
			Cell: props => (
				<ActionColumn
					onDeleteClick={() => { if (!props?.original?.isDefault) { dispatch(toggleModal({ open: 'deleteModal' })); setSelectedData({ title: 'Module', ...props?.original, name: props?.original?.moduleName, identifier: MODULE_TYPE.MODULE }) } }}
					onEditClick={() => { if (!props?.original?.isDefault) { dispatch(toggleModal({ open: 'addEditModule' })); setSelectedData({ title: 'Edit Module', ...props?.original }); setModuleName(props?.original?.moduleName) } }}
					props={props}
				/>
			)
		},
	];

	let tabsAndKeys = {
		"Two Minute Audit - Investment": {
			title: 'Two Minute Audit - Investment',
			name: "two-minute-test-investment",
		}, "Two Minute Audit - Growth": {
			title: 'Two Minute Audit - Growth',
			name: "two-minute-test-growth",
		}, "Two Minute Audit - Exit": {
			title: 'Two Minute Audit - Exit',
			name: "two-minute-test-exit",
		}, "Repository": {
			name: "repository",
			title: 'Repository',
		}, "Business Audit - Investment": {
			name: "business-audit-investment",
			title: "Business Audit - Investment",
		}, "Business Audit - Growth": {
			name: "business-audit-growth",
			title: "Business Audit - Growth",
		}, "Business Audit - Exit": {
			name: "business-audit-exit",
			title: "Business Audit - Exit",
		}, "Warranty Disclosure": {
			expansionPack: true,
			name: "warranty-disclosure",
			title: 'Warranty Disclosure',
		}, "Directors Questionnaire": {
			expansionPack: true,
			name: "directors-questionnaire",
			title: 'Directors Questionnaire',
		}, "Software Development": {
			expansionPack: true,
			name: "software-development",
			title: 'Software Development',
		}, "ESG": {
			name: "esg",
			title: 'ESG',
			expansionPack: true,
		}, "Investor Lead Introduction": {
			name: "investor-lead",
			title: 'Investor Lead Introduction',
			expansionPack: true,
		}
	};

	useEffect(() => {
		const newTab = location.hash.replace("#", "").replace(/_/g, " ").replace("AI ", "");
		setTab(newTab);
	}, [location.hash]);

	// Getting all allocation tab's table data adn calling it again when some action perform
	useEffect(() => {
		getAllPartners();
		getAllCompaniesUsers('User');
		getQuestions();
		getSections()
		getCategorys()
		getModules();
		getModule();
	}, []);


	useEffect(() => {
		if (panel == 'Companies') setSubPanel('Subscribed Companies');
		else if (panel == 'ChatGPT') setSubPanel('Business Audit');
		else if (panel === "Allocation Management") setSubPanel('Category Management')
	}, [panel]);

	useEffect(() => {
		location.hash = ((aiTest ? "AI " : "") + tab).replace(/\s/g, "_")
	}, [tab, aiTest]);

	const getModule = async () => {
		let moduleResponse = await getRequest(`/admin/view/module`)
		setModuleList(moduleResponse['body'])
	};

	const getCategorys = async () => {
		let categoryResponse = await getRequest(`/admin/view/category`)
		setCategoryList(categoryResponse['body'])
	};

	const getSections = async () => {
		let sectionResponse = await getRequest(`/admin/view/section/existingsections`)
		setSectionList(sectionResponse['body'])
		let expensionPackResponse = await getRequest(`/admin/view/section/expensionpack`)
		setExpensionPackList(expensionPackResponse['body'])
	};

	const getModules = async () => {
		let usersResponse = await getRequest(`/repository/getModule`);
		setTabsAndKeysForChecklist(usersResponse['body']);
	};

	const activeModule = async (moduleId, moduleName, isActive) => {
		let res = await postRequest(`/repository/activeModule`, { moduleId, moduleName, isActive });
		if (res?.code === 200) {
			showMessage(res['message']);
			await getModules();
		}
	};

	const deleteModule = async (moduleName) => {
		let res = await postRequest(`/repository/deleteModule`, { moduleName });
		if (res?.code === 200) {
			showMessage(res['message']);
			await getModules();
		}
	};

	const getAllCompaniesUsers = async (role = null, superUser = null, yopmailOnly = false) => {
		let url = '/user/getAllUsers';
		if (role) url += `?role=${role}`;
		if (superUser && superUser !== 'All') url += `&superUser=${superUser}`;
		if (yopmailOnly) url += (url.includes('?') ? '&' : '?') + `yopmailOnly=true`;

		let usersResponse = await getRequest(url);
		if (usersResponse && usersResponse?.code === 200) {
			// For Advisors, response is { users, superUsers }
			// For Users, response is just the array
			if (role === 'Advisor' && usersResponse['body']?.users) {
				setAllUsers(usersResponse['body'].users);
				setSuperUserOptions(usersResponse['body'].superUsers || []);
			} else setAllUsers(usersResponse['body']);

		}
	};

	const getQuestions = async () => {
		// setSectionsAndQuestions({});
		let res = await getRequest(`/question/getAllQuestions`);
		if (res?.code === 200) setSectionsAndQuestions(res.body);
	};

	let iconClasses = "center-vertically f3 pa l0 ml1rem br5px mah2rem maw2rem";
	let inputValues = {
		"qDescription": { title: 'Question Description', placeholder: 'Please add you question description', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path className="fa-primary" d="M256 336c-18 0-32 14-32 32c0 18 13.1 32 32 32c17.1 0 32-13.1 32-32C288 350 273.1 336 256 336zM289.1 128h-51.1C198.1 128 168 158.1 168 198c0 12.1 11 24 24 24s24-11 24-24C216 186 225.1 176 237.1 176h51.1C301.1 176 312 186 312 198c0 8-4 14.1-11 18.1L244 251C236 256 232 264 232 272V288c0 13 11 24 24 24S280 301 280 288V286l45.1-28c21-13 34-36 34-60C360 158.1 328.1 128 289.1 128z" /><path className="fa-secondary" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 400c-18 0-32-14-32-32s13.1-32 32-32c17.1 0 32 14 32 32S273.1 400 256 400zM325.1 258L280 286V288c0 13-11 24-24 24S232 301 232 288V272c0-8 4-16 12-21l57-34C308 213 312 206 312 198C312 186 301.1 176 289.1 176h-51.1C225.1 176 216 186 216 198c0 13-11 24-24 24s-24-11-24-24C168 159 199 128 237.1 128h51.1C329 128 360 159 360 198C360 222 347 245 325.1 258z" /></svg> },
		"topTip": { title: 'Tool Tip', placeholder: 'Please provide tooltip for help', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path className="fa-primary" d="M240.1 415.1l.0167 38.36c0 6.297 1.89 12.43 5.359 17.68l17.09 25.69c5.25 7.875 17.18 14.28 26.65 14.28h61.72c9.438 0 21.38-6.394 26.63-14.27l17.09-25.69C397.6 467.6 400 459.7 400 454.4l.1562-70.35l-159.9 .002L240.1 415.1zM112 192c0-13.25-10.75-24-24-24h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64C101.3 216 112 205.3 112 192zM616 168h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64c13.25 0 24-10.75 24-24S629.3 168 616 168zM131.1 55.25l-55.5-32C68.25 18.75 59 18.63 51.38 22.88c-7.5 4.375-12.13 12.37-12.13 21c.125 8.75 4.875 16.75 12.38 20.88L107.1 96.75C114.5 101.3 123.8 101.4 131.4 97.13c7.5-4.375 12.12-12.37 12.12-21C143.4 67.38 138.6 59.38 131.1 55.25zM588.4 319.3l-55.5-32c-7.375-4.5-16.62-4.625-24.25-.375c-7.5 4.375-12.12 12.37-12.12 21c.125 8.75 4.875 16.75 12.38 20.88l55.5 32c11.38 6.375 25.88 2.375 32.38-9C603.3 340.5 599.5 326 588.4 319.3zM107.1 287.3L51.62 319.3c-7.5 4.125-12.25 12.12-12.38 20.88c0 8.625 4.625 16.63 12.13 21c7.625 4.25 16.87 4.125 24.25-.375l55.5-32c11.12-6.75 14.87-21.25 8.375-32.5C133 284.9 118.5 280.9 107.1 287.3zM521 100c4.125 0 8.25-1.125 12-3.25l55.38-32c11.25-6.75 14.88-21.25 8.375-32.5c-6.5-11.38-21-15.38-32.38-9L509 55.25c-9.5 5.375-14 16.5-11.25 27C500.6 92.75 510.1 100 521 100z" /><path className="fa-secondary" d="M319.5 .0154C217.5 .2654 144 82.1 144 175.1c0 42.63 15.4 83.76 43.52 115.8c16.62 18.88 42.36 58.23 52.24 91.48c0 .25 .1146 .5105 .1146 .7604l160.3 .0007c0-.25 .0833-.5111 .0833-.7611c9.875-33.25 35.61-72.61 52.24-91.48C480.6 259.8 496 218.6 496 175.1C496 78.62 416.8-.2346 319.5 .0154zM320 96.01c-44.13 0-80 35.87-80 79.1c0 8.875-7.125 16-16 16s-16-7.125-16-16C208.1 114.1 258.1 64.14 320 64.01c8.875 0 16 7.126 16 16S328.9 96.01 320 96.01z" /></svg> },
		"toolboxOffer": { title: 'Tool Box Offer', placeholder: 'Please provide toolbox offer for help', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path className="fa-primary" d="M512 205.3V320h-128V272C384 263.1 376.9 256 368 256h-32C327.1 256 320 263.1 320 272V320H192V272C192 263.1 184.9 256 176 256h-32C135.1 256 128 263.1 128 272V320H0V205.3c0-8.5 3.375-16.62 9.375-22.62l45.25-45.25C60.63 131.4 68.75 128 77.25 128h357.5c8.5 0 16.62 3.375 22.62 9.375l45.25 45.25C508.6 188.6 512 196.8 512 205.3z" /><path className="fa-secondary" d="M384 320v48c0 8.875-7.125 16-16 16h-32c-8.875 0-16-7.125-16-16V320H192v48C192 376.9 184.9 384 176 384h-32C135.1 384 128 376.9 128 368V320H0v128c0 17.62 14.38 32 32 32h448c17.62 0 32-14.38 32-32v-128H384zM176 80h160V128H384V80C384 53.5 362.5 32 336 32h-160C149.5 32 128 53.5 128 80V128h48V80z" /></svg> },
		"templateFiles": { title: 'Template File', placeholder: 'Please provide template file to help company understand how they can format this document before uploading (optional)', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path className="fa-primary" d="M292 312h-4.422c-3.256 .1484-24.48 1.359-54.15 6.406c-11.75-10.84-21.61-23.59-29.44-38.05c1.047-3.207 2.076-6.449 3.082-9.723C208.8 263.8 216 232.1 216 208c0-22.05-17.94-40-40-40c-22.05 0-40 17.95-40 40c0 .3555 .1973 34.39 16.53 74.36c-8.396 23.11-18.58 46.31-30.33 69.14c-25.65 12.07-46.84 26.54-63.02 43.05C51.74 402.2 48 412.1 48 424.1C48 446.1 65.92 464 87.94 464c12.9 0 25.04-6.238 32.48-16.68c8.74-12.27 21.94-32.1 36.37-58.41c18.86-7.582 40.44-13.99 64.31-19.1c16.18 11.43 34.5 20.64 54.55 27.39C281.1 399 286.9 400 292.9 400C317.1 400 336 380.7 336 356C336 331.7 316.3 312 292 312zM94.38 428.8C90.47 434.3 80 432 80 422.4c0-2.094 .75-4.094 2.062-5.438c10.77-11 23.8-20.34 38.02-28.31C108.8 408 99.27 421.9 94.38 428.8zM176 200c4.406 0 8 3.594 8 8c0 18.16-4.906 41.59-6.859 50.25C168.3 231.3 168 210.1 168 208C168 203.6 171.6 200 176 200zM156.5 354.6c7.891-16.09 15.78-33.97 23.12-53.34c7.625 13.03 17.38 26.09 29.8 38.16C192.7 343.2 174.5 348.1 156.5 354.6zM292.9 368c-2.422 0-4.844-.375-6.984-1.125c-14.72-4.938-27.58-11.12-38.84-18.12C271.2 344.1 287.7 344 288 344h4c6.609 0 12 5.375 12 12.88C304 363 299 368 292.9 368zM256 0v128h128L256 0z" /><path className="fa-secondary" d="M184 208c0-4.406-3.594-8-8-8S168 203.6 168 208c0 2.062 .2969 23.31 9.141 50.25C179.1 249.6 184 226.2 184 208zM156.5 354.6c17.98-6.5 36.13-11.44 52.92-15.19c-12.42-12.06-22.17-25.12-29.8-38.16C172.3 320.6 164.4 338.5 156.5 354.6zM80 422.4c0 9.656 10.47 11.97 14.38 6.375C99.27 421.9 108.8 408 120.1 388.6c-14.22 7.969-27.25 17.31-38.02 28.31C80.75 418.3 80 420.3 80 422.4zM256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM292.9 400c-5.994 0-11.81-.9531-17.22-2.805c-20.06-6.758-38.38-15.96-54.55-27.39c-23.88 5.109-45.46 11.52-64.31 19.1c-14.43 26.31-27.63 46.15-36.37 58.41C112.1 457.8 100.8 464 87.94 464C65.92 464 48 446.1 48 424.1c0-11.92 3.74-21.82 11.18-29.51c16.18-16.52 37.37-30.99 63.02-43.05c11.75-22.83 21.94-46.04 30.33-69.14C136.2 242.4 136 208.4 136 208c0-22.05 17.95-40 40-40c22.06 0 40 17.95 40 40c0 24.1-7.227 55.75-8.938 62.63c-1.006 3.273-2.035 6.516-3.082 9.723c7.83 14.46 17.7 27.21 29.44 38.05C263.1 313.4 284.3 312.1 287.6 312H292c24.26 0 44 19.74 44 44C336 380.7 317.1 400 292.9 400zM292 344H288c-.3438 .0313-16.83 .9687-40.95 4.75c11.27 7 24.12 13.19 38.84 18.12C288 367.6 290.5 368 292.9 368C299 368 304 363 304 356.9C304 349.4 298.6 344 292 344z" /></svg> },
		"riskDescription": { title: 'Risk Description', placeholder: 'Please provide Risk Description if answer is negative (NO)', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path className="fa-primary" d="M256 304c13.25 0 24-10.75 24-24v-128C280 138.8 269.3 128 256 128S232 138.8 232 152v128C232 293.3 242.8 304 256 304zM256 337.1c-17.36 0-31.44 14.08-31.44 31.44C224.6 385.9 238.6 400 256 400s31.44-14.08 31.44-31.44C287.4 351.2 273.4 337.1 256 337.1z" /><path className="fa-secondary" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z" /></svg> },
		"recommendDescription": { title: 'Recommendation Description', placeholder: 'Please provide Recommendation if answer is negative (NO)', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path className="fa-primary" d="M240.1 415.1l.0167 38.36c0 6.297 1.89 12.43 5.359 17.68l17.09 25.69c5.25 7.875 17.18 14.28 26.65 14.28h61.72c9.438 0 21.38-6.394 26.63-14.27l17.09-25.69C397.6 467.6 400 459.7 400 454.4l.1562-70.35l-159.9 .002L240.1 415.1zM112 192c0-13.25-10.75-24-24-24h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64C101.3 216 112 205.3 112 192zM616 168h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64c13.25 0 24-10.75 24-24S629.3 168 616 168zM131.1 55.25l-55.5-32C68.25 18.75 59 18.63 51.38 22.88c-7.5 4.375-12.13 12.37-12.13 21c.125 8.75 4.875 16.75 12.38 20.88L107.1 96.75C114.5 101.3 123.8 101.4 131.4 97.13c7.5-4.375 12.12-12.37 12.12-21C143.4 67.38 138.6 59.38 131.1 55.25zM588.4 319.3l-55.5-32c-7.375-4.5-16.62-4.625-24.25-.375c-7.5 4.375-12.12 12.37-12.12 21c.125 8.75 4.875 16.75 12.38 20.88l55.5 32c11.38 6.375 25.88 2.375 32.38-9C603.3 340.5 599.5 326 588.4 319.3zM107.1 287.3L51.62 319.3c-7.5 4.125-12.25 12.12-12.38 20.88c0 8.625 4.625 16.63 12.13 21c7.625 4.25 16.87 4.125 24.25-.375l55.5-32c11.12-6.75 14.87-21.25 8.375-32.5C133 284.9 118.5 280.9 107.1 287.3zM521 100c4.125 0 8.25-1.125 12-3.25l55.38-32c11.25-6.75 14.88-21.25 8.375-32.5c-6.5-11.38-21-15.38-32.38-9L509 55.25c-9.5 5.375-14 16.5-11.25 27C500.6 92.75 510.1 100 521 100z" /><path className="fa-secondary" d="M319.5 .0154C217.5 .2654 144 82.1 144 175.1c0 42.63 15.4 83.76 43.52 115.8c16.62 18.88 42.36 58.23 52.24 91.48c0 .25 .1146 .5105 .1146 .7604l160.3 .0007c0-.25 .0833-.5111 .0833-.7611c9.875-33.25 35.61-72.61 52.24-91.48C480.6 259.8 496 218.6 496 175.1C496 78.62 416.8-.2346 319.5 .0154zM320 96.01c-44.13 0-80 35.87-80 79.1c0 8.875-7.125 16-16 16s-16-7.125-16-16C208.1 114.1 258.1 64.14 320 64.01c8.875 0 16 7.126 16 16S328.9 96.01 320 96.01z" /></svg> },

		"noPoints": { title: 'Points on No', placeholder: '', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path className="fa-secondary" d="M384 64.01v384c0 13.47-8.438 25.5-21.09 30.09C359.3 479.4 355.7 480 352 480c-9.312 0-18.38-4.078-24.59-11.52L64 152.4v295.6c0 17.67-14.31 32-32 32s-32-14.33-32-32v-384c0-13.47 8.438-25.5 21.09-30.09c12.62-4.516 26.84-.75 35.5 9.609L320 359.6v-295.6c0-17.67 14.31-32 32-32S384 46.34 384 64.01z" /></svg> },
		"yesPoints": { title: 'Points on Yes', placeholder: '', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path className="fa-secondary" d="M378 82.61L224 298.3v149.8c0 17.67-14.31 31.1-32 31.1S160 465.7 160 448V298.3L5.969 82.61C-4.313 68.23-.9688 48.25 13.41 37.97c14.34-10.27 34.38-6.922 44.63 7.453L192 232.1l133.1-187.5c10.28-14.37 30.28-17.7 44.63-7.453C384.1 48.25 388.3 68.23 378 82.61z" /></svg> },
		"completionScore": { title: 'Points on Completion', placeholder: '', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path className="fa-primary" d="M335.9 371c-9.715 8.604-15.9 20.65-15.9 33.62C319.1 428.7 339.3 448 363.4 448h4.644c26.51 0 47.99 21.49 47.99 48c0 8.836-7.162 16-15.1 16H176c-8.836 0-15.1-7.164-15.1-16c0-26.51 21.48-48 47.99-48h4.644c24.03 0 43.36-19.33 43.36-43.35c0-12.98-6.184-25.02-15.9-33.62C128 271.7 128 96 128 96L128 32c0-17.67 14.5-32 32.17-32h255.7C433.5 0 448 14.33 448 32l-.0059 64C447.1 96 447.1 271.7 335.9 371z" /><path className="fa-secondary" d="M193.7 316.9C189.8 311.1 186.2 305.3 182.8 299.4c-47.14-19.35-82.56-45.83-105.4-79.52C49.47 178.6 47.01 135.7 48.38 112h80.39C128.1 101.9 128 96 128 96L128.1 64H27.26C16.16 64 6.537 71.59 3.912 82.38C3.1 85.78-15.71 167.2 37.07 245.9c37.45 55.82 100.6 95.03 187.5 117.4c8.828 2.268 17.76 9.74 15.51 7.75C211.9 346 194.2 317.4 193.7 316.9zM572.1 82.38C569.5 71.59 559.8 64 548.7 64h-100.8l.0811 32c0 0-.0953 5.926-.7652 16h80.39c1.375 23.66-1.093 66.63-29.03 107.8c-22.82 33.69-58.25 60.17-105.4 79.52c-3.402 5.91-7.023 11.73-10.86 17.5c-.5352 .5352-18.2 29.14-46.45 54.16c-2.248 1.99 6.687-5.482 15.51-7.75c86.96-22.34 150.1-61.55 187.5-117.4C591.7 167.2 572.9 85.78 572.1 82.38z" /></svg> },
		"filePoints": { title: 'Points on File Upload', placeholder: '', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path className="fa-secondary" d="M640 352c0 70.7-57.31 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9C96.11 197.4 96 194.7 96 192c0-88.41 71.59-160 160-160c59.31 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.312 23.91-6.406 34.59C596 238.4 640 290.1 640 352z" /></svg> },
		"commentPoints": { title: 'Points on Comment', placeholder: '', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path className="fa-secondary" d="M256 32C114.6 32 .0272 125.1 .0272 240c0 49.63 21.35 94.98 56.97 130.7c-12.5 50.37-54.27 95.27-54.77 95.77c-2.25 2.25-2.875 5.734-1.5 8.734C1.979 478.2 4.75 480 8 480c66.25 0 115.1-31.76 140.6-51.39C181.2 440.9 217.6 448 256 448c141.4 0 255.1-93.13 255.1-208S397.4 32 256 32z" /></svg> },
		"ifYes": { title: 'Yes Recommendation', placeholder: 'Recommendation if Yes', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path className="fa-secondary" d="M378 82.61L224 298.3v149.8c0 17.67-14.31 31.1-32 31.1S160 465.7 160 448V298.3L5.969 82.61C-4.313 68.23-.9688 48.25 13.41 37.97c14.34-10.27 34.38-6.922 44.63 7.453L192 232.1l133.1-187.5c10.28-14.37 30.28-17.7 44.63-7.453C384.1 48.25 388.3 68.23 378 82.61z" /></svg> },
		"ifNo": { title: 'No Recommendation', placeholder: 'Recommendation if No', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path className="fa-secondary" d="M384 64.01v384c0 13.47-8.438 25.5-21.09 30.09C359.3 479.4 355.7 480 352 480c-9.312 0-18.38-4.078-24.59-11.52L64 152.4v295.6c0 17.67-14.31 32-32 32s-32-14.33-32-32v-384c0-13.47 8.438-25.5 21.09-30.09c12.62-4.516 26.84-.75 35.5 9.609L320 359.6v-295.6c0-17.67 14.31-32 32-32S384 46.34 384 64.01z" /></svg> },
		"if1": { title: 'Option 1 Recommendation', placeholder: 'Recommendation if selected option is 1', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path className="fa-secondary" d="M256 448c0 17.67-14.33 32-32 32H32c-17.67 0-32-14.33-32-32s14.33-32 32-32h64V123.8L49.75 154.6C35.02 164.5 15.19 160.4 5.375 145.8C-4.422 131.1-.4531 111.2 14.25 101.4l96-64c9.828-6.547 22.45-7.187 32.84-1.594C153.5 41.37 160 52.22 160 64.01v352h64C241.7 416 256 430.3 256 448z" /></svg> },
		"if2": { title: 'Option 2 Recommendation', placeholder: 'Recommendation if selected option is 2', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path className="fa-secondary" d="M320 448c0 17.67-14.33 32-32 32H32c-13.08 0-24.83-7.953-29.7-20.09c-4.859-12.12-1.859-26 7.594-35.03l193.6-185.1c31.36-30.17 33.95-80 5.812-113.4c-14.91-17.69-35.86-28.12-58.97-29.38C127.4 95.83 105.3 103.9 88.53 119.9L53.52 151.7c-13.08 11.91-33.33 10.89-45.2-2.172C-3.563 136.5-2.594 116.2 10.48 104.3l34.45-31.3c28.67-27.34 68.39-42.11 108.9-39.88c40.33 2.188 78.39 21.16 104.4 52.03c49.8 59.05 45.2 147.3-10.45 200.8l-136 130H288C305.7 416 320 430.3 320 448z" /></svg> },
		"if3": { title: 'Option 3 Recommendation', placeholder: 'Recommendation if selected option is 3', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path className="fa-secondary" d="M320 344c0 74.98-61.02 136-136 136H103.6c-46.34 0-87.31-29.53-101.1-73.48c-5.594-16.77 3.484-34.88 20.25-40.47c16.75-5.609 34.89 3.484 40.47 20.25c5.922 17.77 22.48 29.7 41.23 29.7H184c39.7 0 72-32.3 72-72s-32.3-72-72-72H80c-13.2 0-25.05-8.094-29.83-20.41C45.39 239.3 48.66 225.3 58.38 216.4l131.4-120.4H32c-17.67 0-32-14.33-32-32s14.33-32 32-32h240c13.2 0 25.05 8.094 29.83 20.41c4.781 12.3 1.516 26.27-8.203 35.19l-131.4 120.4H184C258.1 208 320 269 320 344z" /></svg> },
		"if4": { title: 'Option 4 Recommendation', placeholder: 'Recommendation if selected option is 4', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path className="fa-secondary" d="M384 334.2c0 17.67-14.33 32-32 32h-32v81.78c0 17.67-14.33 32-32 32s-32-14.33-32-32v-81.78H32c-10.97 0-21.17-5.625-27.05-14.89c-5.859-9.266-6.562-20.89-1.875-30.81l128-270.2C138.6 34.33 157.8 27.56 173.7 35.09c15.97 7.562 22.78 26.66 15.22 42.63L82.56 302.2H256V160c0-17.67 14.33-32 32-32s32 14.33 32 32v142.2h32C369.7 302.2 384 316.6 384 334.2z" /></svg> },
		"if5": { title: 'Option 5 Recommendation', placeholder: 'Recommendation if selected option is 5', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path className="fa-secondary" d="M320 344.6c0 74.66-60.73 135.4-135.4 135.4H104.7c-46.81 0-88.22-29.83-103-74.23c-5.594-16.77 3.469-34.89 20.23-40.48c16.83-5.625 34.91 3.469 40.48 20.23c6.078 18.23 23.08 30.48 42.3 30.48h79.95c39.36 0 71.39-32.03 71.39-71.39s-32.03-71.38-71.39-71.38H32c-9.484 0-18.47-4.203-24.56-11.48C1.359 254.5-1.172 244.9 .5156 235.6l32-177.2C35.27 43.09 48.52 32.01 64 32.01l192 .0049c17.67 0 32 14.33 32 32s-14.33 32-32 32H90.73L70.3 209.2h114.3C259.3 209.2 320 269.1 320 344.6z" /></svg> },
		"ifD": { title: 'Disclosure Recommendation', placeholder: 'Recommendation if selected option is Disclosure', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path className="fa-secondary" d="M256 448c0 17.67-14.33 32-32 32H32c-17.67 0-32-14.33-32-32s14.33-32 32-32h64V123.8L49.75 154.6C35.02 164.5 15.19 160.4 5.375 145.8C-4.422 131.1-.4531 111.2 14.25 101.4l96-64c9.828-6.547 22.45-7.187 32.84-1.594C153.5 41.37 160 52.22 160 64.01v352h64C241.7 416 256 430.3 256 448z" /></svg> },
		"ifND": { title: 'Non-Disclosure Recommendation', placeholder: 'Recommendation if selected option is Non Disclosure', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path className="fa-secondary" d="M320 448c0 17.67-14.33 32-32 32H32c-13.08 0-24.83-7.953-29.7-20.09c-4.859-12.12-1.859-26 7.594-35.03l193.6-185.1c31.36-30.17 33.95-80 5.812-113.4c-14.91-17.69-35.86-28.12-58.97-29.38C127.4 95.83 105.3 103.9 88.53 119.9L53.52 151.7c-13.08 11.91-33.33 10.89-45.2-2.172C-3.563 136.5-2.594 116.2 10.48 104.3l34.45-31.3c28.67-27.34 68.39-42.11 108.9-39.88c40.33 2.188 78.39 21.16 104.4 52.03c49.8 59.05 45.2 147.3-10.45 200.8l-136 130H288C305.7 416 320 430.3 320 448z" /></svg> },
		"ifNS": { title: 'Not Selected Recommendation', placeholder: 'Recommendation if selected option is Not Selected', icon: <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path className="fa-secondary" d="M320 344c0 74.98-61.02 136-136 136H103.6c-46.34 0-87.31-29.53-101.1-73.48c-5.594-16.77 3.484-34.88 20.25-40.47c16.75-5.609 34.89 3.484 40.47 20.25c5.922 17.77 22.48 29.7 41.23 29.7H184c39.7 0 72-32.3 72-72s-32.3-72-72-72H80c-13.2 0-25.05-8.094-29.83-20.41C45.39 239.3 48.66 225.3 58.38 216.4l131.4-120.4H32c-17.67 0-32-14.33-32-32s14.33-32 32-32h240c13.2 0 25.05 8.094 29.83 20.41c4.781 12.3 1.516 26.27-8.203 35.19l-131.4 120.4H184C258.1 208 320 269 320 344z" /></svg> },
	};

	function getQuestionKeys(question) {
		let keys = ['qDescription']; // 'commentPoints', 'filePoints', 'completionScore'], //TODO: maybe use later
		if (question['questionType'].includes('F')) keys.push('templateFiles');
		if (['esg', 'software-development', 'directors-questionnaire', 'warranty-disclosure', 'repository'].includes(question['type'])) keys = keys.concat(['topTip', 'toolboxOffer']);
		if (['esg', 'software-development', 'business-audit-investment', 'business-audit-growth', 'business-audit-exit'].includes(question['type'])) keys = keys.concat(['riskDescription', 'recommendDescription']);
		else if (question['questionType'].includes('YN') && question['type'] != 'repository') keys = keys.concat(['ifYes', 'riskIfYes', 'ifNo', 'riskIfNo']);

		if (question['questionType'].includes('1to5')) keys = keys.concat(['if1', 'riskIf1', 'if2', 'riskIf2', 'if3', 'riskIf3', 'if4', 'riskIf4', 'if5', 'riskIf5']);
		if (question['questionType'].includes('D/ND')) keys = keys.concat(['ifD', 'riskIfD', 'ifNS', 'riskIfNS', 'ifND', 'riskIfND']);

		return [...keys];
	};

	const onDragOver = e => e.preventDefault();
	const onDrop = (e, question, sectionIndex, questionIndex, module) => {
		e.preventDefault();
		e.target.files = e.dataTransfer.files;
		e.target.querySelector("input").value = null;
		saveQuestion(e, question, sectionIndex, questionIndex, module);
	};

	const confirmDeleteFile = async () => {
		const res = await postRequest('/repository/deleteTemplate', { file: deleteFile, questionId: deleteFileQuestionId });
		if (!res || res['code'] != 200) return;

		dispatch(toggleModal({ open: '' }));
		getQuestions();
		showMessage(res['message']);
	};

	const saveQuestion = async (e, question, sectionIndex, questionIndex, module) => {
		let attachment = [];
		if (e.target.files) for (const file of e.target.files) attachment.push(file);

		let res = await postRequest(`/question/update`, { attachment, questionId: question['_id'], [e.target.name]: e.target.value });
		if (!res || res['code'] != 200) return;
		if (e.target.files) {
			getQuestions();
		}
		showMessage(res['message']);
		//setSectionsAndQuestions(); //TODO: update this
	};

	const getDeletedCompaniesLogs = async () => {
		const response = await postRequest('/log', { endpoint: '/company/adminDeleteCompany' });
		if (response && response['code'] == 200) {
			setDeletedCompaniesLogs(response['body']);
			dispatch(toggleModal({ open: 'deletedCompaniesLogs' }));
		}
	};

	const submitDeleteCompany = async (companyId) => {
		let requestBody = {
			companyId: deleteCompany?.['_id'],
			companyName: deleteCompany?.['cName'],
			creatorId: deleteCompany?.['creatorId']?.['_id'],
			creatorEmail: deleteCompany?.['creatorId']?.['email'],
			creatorName: `${deleteCompany?.['creatorId']?.['firstName']} ${deleteCompany?.['creatorId']?.['lastName']}`,
		};
		let response = await postRequest(`/company/adminDeleteCompany`, requestBody);
		if (response && response['code'] == 200) {
			await getAllCompaniesUsers();
			dispatch(toggleModal({ open: '' }));
			showMessage(response['message']);
		};
	};

	// Filtering the data into table using case-in-sensitive
	const filterCaseInsensitive = (filter, row) => {
		const id = filter['pivotId'] || filter['id'];
		const content = row[id];
		if (typeof content !== 'undefined') {
			if (typeof content === 'object' && content !== null && content.key)
				return String(content['key']).toLowerCase().includes(filter['value'].toLowerCase());
			else return String(content).toLowerCase().includes(filter['value'].toLowerCase());
		}
		return true;
	};

	const submitDeleteUser = async (userId) => {
		let res = await getRequest(`/user/deleteUser/${userId}`);
		if (!res || res['code'] != 200) return;
		showMessage(res['message']);
		window.location.reload();
	};

	const modulesTab = () => {
		return (
			<div className="bg1 shadow p2rem dg gg2rem">
				<div className="bss bw2px bo5 br10px p2rem dg gtcr5-md gg2rem">
					<h3 className="gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7">Modules</h3>
					{Object.keys(tabsAndKeys).map((s, idx) => (
						<button key={idx} onClick={() => setTab(s)} className="shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss mih4rem">{s}</button>
					))}
				</div>
			</div>
		);
	};

	const companiesTab = () => {
		return (
			<div className="df fdc aic advisor-index zi2 pr">
				<TabContext value={subPanel}>
					<TabList onChange={(e, value) => setSubPanel(value)}>
						<Tab className="fs1rem fw600" label='Subscribed Companies' value='Subscribed Companies' />
						<Tab className="fs1rem fw600" label='Archived Companies' value='Archived Companies' />
						<Tab className="fs1rem fw600" label='Yopmail Companies' value='Yopmail Companies' />
					</TabList>
					<button onClick={() => getDeletedCompaniesLogs()} className='cp tac c1 bg3 bg4-hover br5px shadow px1rem py0-5rem fw500 pa r0'>Audit Log</button>
					<TabPanel className='w100' value='Subscribed Companies'>
						<SubscribedCompaniesTab isArchived={false} setDeleteCompany={setDeleteCompany} handleRevenueLeadMode={handleRevenueLeadMode} />
					</TabPanel>
					<TabPanel className='w100' value='Archived Companies'>
						<SubscribedCompaniesTab isArchived={true} setDeleteCompany={setDeleteCompany} handleRevenueLeadMode={handleRevenueLeadMode} />
					</TabPanel>
					<TabPanel className='w100' value='Yopmail Companies'>
						<SubscribedCompaniesTab isArchived={false} isYopmail={true} setDeleteCompany={setDeleteCompany} handleRevenueLeadMode={handleRevenueLeadMode} />
					</TabPanel>
				</TabContext>
			</div>
		);
	};

	const usersColumns = [{
		id: 'name',
		Header: 'Name',
		accessor: user => (user['firstName'] || user['lastName']) ? (user['firstName'] || '-') + " " + (user['lastName'] || '-') : '-',
	}, {
		id: 'email',
		Header: 'Email',
		width: 350,
		accessor: user => user['email'] ? <p className="ttl">{user['email']}</p> : '-',
	}, {
		id: 'createdAt',
		Header: 'Created At',
		accessor: user => user['createdAt'] ? moment(user['createdAt']).format('DD/MMM/YY') : '-',
	}, {
		id: 'role',
		Header: 'Role',
		accessor: user => user['role'] ? user['role'] : '-',
	},
	{
		id: 'advisorType',
		Header: 'Advisor Type',
		accessor: user => user['advisorType'] && user['advisorType']['name'] ? user['advisorType']['name'] : '-',
	},
	{
		id: 'lastLoginAt',
		Header: 'Last Login',
		accessor: user => user['lastLoginAt'],
	}, {
		id: 'timezone',
		Header: 'Time Zone',
		accessor: user => user['timezone'] ? user['timezone'] : '-',
	},
	{
		id: 'action',
		Header: 'Revenue Lead',
		accessor: (user) => {
			return (
				<>
					<input type="checkbox" checked={user?.revenueLeadMode ?? false} onChange={(e) => handleRevenueLeadMode(user, { revenueLeadMode: e.target.checked }, 'user')} />
				</>
			)
		},
	},
	{
		id: 'delete',
		Header: 'Delete',
		accessor: user => <button onClick={() => { setDeleteUser(user), dispatch(toggleModal({ open: 'deleteUserPopup' })) }} style={{ backgroundColor: "transparent" }}><i data-tooltip="Delete User" className="fa fa-trash c9 cp" style={{ fontSize: '20px' }} /></button>
	}];

	const advisorsColumns = [{
		id: 'name',
		Header: 'Name',
		accessor: user => (user['firstName'] || user['lastName']) ? (user['firstName'] || '-') + " " + (user['lastName'] || '-') : '-',
	}, {
		id: 'email',
		Header: 'Email',
		width: 350,
		accessor: user => user['email'] ? <p className="ttl">{user['email']}</p> : '-',
	}, {
		id: 'title',
		Header: 'Title',
		accessor: user => user['title'] ? user['title'] : '-',
	}, {
		id: 'country',
		Header: 'Country',
		accessor: user => user['country'] ? user['country'] : '-',
	}, {
		id: 'officeLocation',
		Header: 'Office Location',
		accessor: user => user['officeLocation'] ? user['officeLocation'] : '-',
	}, {
		id: 'superUser',
		Header: 'SuperUser',
		accessor: user => user['superUser'] ? user['superUser'] : '-',
	}, {
		id: 'accountStatus',
		Header: 'Account Status',
		accessor: user => user['accountStatus'] ? user['accountStatus'] : '-',
	}, {
		id: 'isRegistered',
		Header: 'Registration Status',
		accessor: user => user['isRegistered'] ? 'Registered' : 'Not Registered',
	}, {
		id: 'createdAt',
		Header: 'Created At',
		accessor: user => user['createdAt'] ? moment(user['createdAt']).format('DD/MMM/YY') : '-',
	}, {
		id: 'delete',
		Header: 'Delete',
		accessor: user => <button onClick={() => { setDeleteUser(user), dispatch(toggleModal({ open: 'deleteUserPopup' })) }} style={{ backgroundColor: "transparent" }}><i data-tooltip="Delete User" className="fa fa-trash c9 cp" style={{ fontSize: '20px' }} /></button>
	}];

	const usersTab = () => {
		// Fetch data when subtab changes
		const handleUsersSubPanelChange = async (e, value) => {
			setUsersSubPanel(value);
			setSuperUserFilter('All'); // Reset filter when switching tabs
			if (value === 'Users') await getAllCompaniesUsers('User');
			else if (value === 'Advisors') await getAllCompaniesUsers('Advisor', 'All');
			else if (value === 'Yopmail Users') await getAllCompaniesUsers(null, null, true);
		};

		// Handle superUser filter change
		const handleSuperUserFilterChange = async (e) => {
			const value = e.target.value;
			setSuperUserFilter(value);
			await getAllCompaniesUsers('Advisor', value);
		};

		return (
			<div className="df fdc aic advisor-index zi2 pr">
				<TabContext value={usersSubPanel}>
					<TabList onChange={handleUsersSubPanelChange}>
						<Tab className="fs1rem fw600" label='Users' value='Users' />
						<Tab className="fs1rem fw600" label='Advisors' value='Advisors' />
						<Tab className="fs1rem fw600" label='Yopmail Users' value='Yopmail Users' />
					</TabList>
					<TabPanel className='w100' value='Users'>
						<div className="bg1 shadow p2rem dg gg2rem">
							<div className="df fdc aic bss bw2px bo5 br10px p2rem">
								<h3 className="gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7">Users Database</h3>
								{allUsers && allUsers.length > 0
									? <div className='admin-table mt1rem w100 ttc tac'>
										<ReactTable
											minRows={20}
											className="table"
											data={allUsers}
											resolveData={user => user.map(row => row)}
											columns={usersColumns}
											filterable={true}
											defaultFilterMethod={filterCaseInsensitive}
										/>
									</div>
									: <p>View Data About All Users</p>
								}
							</div>
						</div>
					</TabPanel>
					<TabPanel className='w100' value='Advisors'>
						<div className="bg1 shadow p2rem dg gg2rem">
							<div className="df fdc aic bss bw2px bo5 br10px p2rem">
								{/* Header with Dropdown on same line */}
								<div className="pr w100 mb1rem">
									<h3 className="gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7">Advisors Database</h3>
									{superUserOptions.length > 0 && (
										<select value={superUserFilter} onChange={handleSuperUserFilterChange} className="p0-5rem br5px pa r0 t0" >
											<option value="All">All</option>
											{superUserOptions.map(su => (<option key={su} value={su}>{su}</option>))}
										</select>
									)}
								</div>

								{allUsers && allUsers.length > 0
									? <div className='admin-table mt1rem w100 ttc tac'>
										<ReactTable
											minRows={20}
											className="table"
											data={allUsers}
											resolveData={user => user.map(row => row)}
											columns={advisorsColumns}
											filterable={true}
											defaultFilterMethod={filterCaseInsensitive}
										/>
									</div>
									: <p>No Advisors Found</p>
								}
							</div>
						</div>
					</TabPanel>
					<TabPanel className='w100' value='Yopmail Users'>
						<div className="bg1 shadow p2rem dg gg2rem">
							<div className="df fdc aic bss bw2px bo5 br10px p2rem">
								<h3 className="gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7">Yopmail Users Database</h3>
								{allUsers && allUsers.length > 0
									? <div className='admin-table mt1rem w100 ttc tac'>
										<ReactTable
											minRows={20}
											className="table"
											data={allUsers}
											resolveData={user => user.map(row => row)}
											columns={usersColumns}
											filterable={true}
											defaultFilterMethod={filterCaseInsensitive}
										/>
									</div>
									: <p>No Yopmail Users Found</p>
								}
							</div>
						</div>
					</TabPanel>
				</TabContext>
			</div>
		);
	};

	const partnersColumns = [{
		id: 'name',
		Header: 'Name',
		accessor: partner => partner['name'] ? partner['name'] : '-',
	}, {
		id: 'moduleKey',
		Header: 'Module Key',
		accessor: partner => partner['moduleKey'] ? partner['moduleKey'] : '-',
	}, {
		id: 'type',
		Header: 'Type',
		accessor: partner => partner['type'] ? partner['type'] : '-',
	}, {
		id: 'testType',
		Header: 'Company Type',
		accessor: partner => partner['testType'] ? partner['testType'] : '-',
	}, {
		id: 'totalChecklists',
		Header: 'Checklist Created',
		accessor: partner => partner['totalChecklists'] ? partner['totalChecklists'] : '-',
	}, {
		id: 'totalUsers',
		Header: 'User Registered',
		accessor: partner => partner['totalUsers'] ? partner['totalUsers'] : '-',
	}, {
		id: 'link',
		Header: 'Link',
		accessor: partner => <a class='c3 c4-hover' href={partner['link']} target="_blank">LINK</a>
	}, {
		id: 'referralCode',
		Header: 'Referral Code',
		accessor: partner => partner['referralCode'] ? partner['referralCode'] : '-',
	}, {
		id: 'action',
		Header: 'Action',
		accessor: partner => <div class='df jcc px1rem'>
			<button className='df cp bg1' onClick={() => handleActionPartner(partner, 'edit')}><i className="fa fa-edit c3"></i></button>
			{/* <button className='df cp bg1' onClick={() => handleActionPartner(partner, 'delete')}><i className="fa fa-trash-o c4"></i></button> */}
		</div>,
	}];

	const getAllPartners = async () => {
		let res = await getRequest(`/checklist/partner`);
		if (res['code'] == 200) setAllPartners(res['body']);
	};

	const handleActivationPartner = async (partner) => {
		setPartner({ ...partner, isActive: !partner['isActive'] });
		setAction('edit');
		dispatch(toggleModal({ open: 'partnerActivationPopup' }));
	};

	const handleActionPartner = async (partner, action) => {
		setPartner(partner);
		await setAction(action);
		dispatch(toggleModal({ open: 'partnerPopup' }));
	};

	const handleAreaFocus = async (e) => {
		let focusArea = { ...partner['focusArea'], [e.target.name]: e.target.value }
		setPartner({ ...partner, focusArea });
	};

	const handleSubmitPartner = async () => {
		let res;
		if (action == 'delete') res = await getRequest(`/checklist/deletePartner/${partner['_id']}`);
		else {
			if (partner['name'] == '') return showMessage(`Please enter name!`);

			partner = { ...partner, action };
			res = await postRequest(`/checklist/partner`, partner);
		}
		if (res['code'] == 200) {
			showMessage(res['message']);
			await getAllPartners();
			setPartner({ name: '', type: 'Business for Funding', testType: 'exit', moduleName: '', moduleKey: '', moduleDescription: '', focusArea: { focus1: '', focus2: '', focus3: '' } });
			dispatch(toggleModal({ open: '' }));
		}
	};

	const handleCreatePartner = async () => {
		await setPartner({ name: '', type: 'Business for Funding', testType: 'exit', moduleName: '', moduleKey: '', moduleDescription: '', focusArea: { focus1: '', focus2: '', focus3: '' } });
		await setAction('create');
		dispatch(toggleModal({ open: 'partnerPopup' }));
	};

	const partnersTab = () => {
		return (
			<div className="bg1 shadow p2rem dg gg2rem">
				<div className="df fdc aic bss bw2px bo5 br10px p2rem">
					<div class='w100 df jcsb'>
						<h3 className="gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7">Partners Database</h3>
						<button onClick={() => handleCreatePartner()} className='df aic jcc cp c1 fw400 fs1rem br38px w200px py0-5rem bg4 bg3-hover'>Create Partner</button>
					</div>
					{allPartners && allPartners.length > 0
						? <div className='admin-table mt1rem w100 ttc tac'>
							<ReactTable
								minRows={20}
								className="table"
								filterable={true}
								data={allPartners}
								columns={partnersColumns}
								defaultFilterMethod={filterCaseInsensitive}
								resolveData={partner => partner.map(row => row)}
							/>
						</div>
						: <p>No Partners Created Yet!</p>
					}
				</div>
			</div>
		);
	};

	const chatGPTTab = () => {
		return (
			<div className="df fdc aic advisor-index zi2">
				<TabContext value={subPanel}>
					<TabList onChange={(e, value) => setSubPanel(value)}>
						<Tab className="fs1rem fw600" label='Business Audit' value='Business Audit' />
						<Tab className="fs1rem fw600" label='DeDuper' value='DeDuper' />
						<Tab className="fs1rem fw600" label='Filing Assistant' value='Filing Assistant' />
						<Tab className="fs1rem fw600" label='Two Minute Audit' value='Two Minute Audit' />
						<Tab className="fs1rem fw600" label='200 Words Test' value='200 Words Test' />
						<Tab className="fs1rem fw600" label='Checklist' value='Checklist' />
					</TabList>
					<TabPanel className='w100' value='Business Audit'>{businessAuditTab()}</TabPanel>
					<TabPanel className='w100' value='DeDuper'>{deDuperTab()}</TabPanel>
					<TabPanel className='w100' value='Filing Assistant'>{filingAssistantTab()}</TabPanel>
					<TabPanel className='w100' value='Two Minute Audit'>{twoMinAuditTab()}</TabPanel>
					<TabPanel className='w100' value='200 Words Test'>{WordsAuditTab()}</TabPanel>
					<TabPanel className='w100' value='Checklist'>{ChecklistTab()}</TabPanel>
				</TabContext>
			</div>
		);
	};

	const kpiTab = () => {
		return (
			<div className="bg1 shadow p2rem dg gg2rem">
				<div className="df fdc aic bss bw2px bo5 br10px p2rem">
					<h3 className="fs1-5rem fs2rem-sm ttu tac c7">KPIs Database</h3>
					<p>Allow viewing and editing of the default KPIs and questions</p>
				</div>
			</div>
		);
	};

	const auditLogTab = () => {
		return (
			<div className="bg1 shadow p2rem dg gg2rem">
				<div className="df fdc aic bss bw2px bo5 br10px p2rem">
					<h3 className="fs1-5rem fs2rem-sm ttu tac c7">Diligentsia Internal Audit Trail Log</h3>
					<p>Log page showing all changes made by admins</p>
					<p>Allow custom logs for development changes</p>
				</div>
			</div>
		);
	};

	const moduleTab = tabsAndKeysForChecklist => {
		return Object.values(tabsAndKeysForChecklist).map((module, idx) => {
			return (
				<div key={`module-${idx}`} className={`df fdc aic advisor-index zi2 pr ha bss br5px ${module.isActive ? 'bo7' : 'bo28'}`}>
					<p className="gcs1 gce6 fs1rem ttu tac c7">{module.moduleName}</p>
					<div className="df fdr">
						<button key={`module-edit-${idx}`}
							onClick={() => setTab(module['_id'])}
							className="shadow h2rem bg5 c6 b1px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo28 bss mih1rem">
							Save
						</button>
						<button key={`module-activate-${idx}`} onClick={() => activeModule(module['moduleName'], module['moduleName'], module['isActive'])} className="shadow h2rem ml1rem bg5 c6 br1px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo28 bss mih1rem">{module.isActive ? "Deactivate" : "Activate"}</button>
					</div>
					<p>Creator: {module.moduleCreator}</p>
					<p>Created Date: {moment(module['createdAt']).format('l')}</p>
					<button key={`module-delete-${idx}`} onClick={() => { setDeleteModuleName(module.moduleName); dispatch(toggleModal({ open: 'confirmDeleteModule' })) }} className="shadow h2rem ml1rem bg5 c6 br1px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo28 bss mih1rem">Delete</button>
				</div>
			);
		});
	};

	const checklistModuleBuilder = () => {
		return (
			<div className="bg1 shadow p2rem dg gg2rem">
				<div className="bss bw2px bo5 br10px p2rem dg gtcr5-md gg2rem">
					<h3 className="gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7">Modules</h3>
					<button onClick={() => setTab("Checklist builder")} className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic">Create New Module</button>
					{tabsAndKeysForChecklist && moduleTab(tabsAndKeysForChecklist)}
				</div>
			</div>
		);
	};

	const businessAuditTab = () => {
		return (
			<div className="bg1 shadow p2rem dg gg2rem">
				<div className="bss bw2px bo5 br10px p2rem dg gtcr3-md gg2rem">
					<h3 className="gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7">Business Audit ChatGPT</h3>
					{Object.keys(tabsAndKeys).filter(s => s.includes('Business')).map(s => (
						<button onClick={() => { setTab(s); setAiTest(true); }} className="shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss ">{s}</button>
					))}
					<button onClick={() => { setTab('ChatGPT-History'); }} className="shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss ">History</button>
				</div>
			</div>
		);
	};

	const deDuperTab = () => {
		return (
			<div className="bg1 shadow p2rem dg gg2rem">
				<div className="bss bw2px bo5 br10px p2rem dg gtcr4-md gg2rem">
					<h3 className="gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7">Deduper ChatGPT</h3>
					<button onClick={() => { setTab('Deduper'); setAiTest(true); }} className="shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss gcs2">Deduper AI</button>
					<button onClick={() => { setTab('Deduper-History'); }} className="shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss  gcs3">History</button>
				</div>
			</div>
		);
	};

	const filingAssistantTab = () => {
		return (
			<div className="bg1 shadow p2rem dg gg2rem">
				<div className="bss bw2px bo5 br10px p2rem dg gtcr4-md gg2rem">
					<h3 className="gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7">Filing Assistant ChatGPT</h3>
					<button onClick={() => { setTab('FA'); setAiTest(true); }} className="shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss  gcs2">Filing Assistant AI</button>
					<button onClick={() => { setTab('FA-History'); }} className="shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss gcs3">History</button>
				</div>
			</div>
		);
	};

	const WordsAuditTab = () => {
		return (
			<div className="bg1 shadow p2rem dg gg2rem">
				<div className="bss bw2px bo5 br10px p2rem dg gtcr4-md gg2rem">
					<h3 className="gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7">200 Words ChatGPT</h3>
					<button onClick={() => { setTab('TH'); setAiTest(true); }} className="shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss  gcs2">200 Words AI</button>
					<button onClick={() => { setTab('TH-History'); }} className="shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss gcs3">History</button>
				</div>
			</div>
		);
	};

	const ChecklistTab = () => {
		return (
			<div className="bg1 shadow p2rem dg gg2rem">
				<div className="bss bw2px bo5 br10px p2rem dg gtcr4-md gg2rem">
					<h3 className="gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7">Checklist ChatGPT</h3>
					<button onClick={() => { setTab('CH'); setAiTest(true); }} className="shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss  gcs2">Checklist AI</button>
					<button onClick={() => { setTab('CH-History'); }} className="shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss gcs3">History</button>
				</div>
			</div>
		);
	};

	const twoMinAuditTab = () => {
		return (
			<div className="bg1 shadow p2rem dg gg2rem">
				<div className="bss bw2px bo5 br10px p2rem dg gtcr3-md gg2rem">
					<h3 className="gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7">Two Minute Audit</h3>
					{Object.keys(tabsAndKeys).filter(s => s.includes('Minute')).map(s => (
						<button onClick={() => { setTab(s); console.log(s); setAiTest(true); }} className="shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss">{s}</button>
					))}
					<button onClick={() => { setTab('TM-History'); }} className="shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss ">History</button>
				</div>
			</div>
		);
	};

	/// Advisor Allocation Tab
	const advisorAllocationTab = () => {
		return (
			<div className="df fdc aic advisor-index zi2 pr">
				<TabContext value={subPanel}>
					<TabList onChange={(e, value) => setSubPanel(value)}>
						<Tab className="fs1rem fw600" label='Category Management' value='Category Management' />
						{/* <Tab className="fs1rem fw600" label='Section Management' value='Section Management' />
							<Tab className="fs1rem fw600" label='Module Management' value='Module Management' /> */}
						<Tab className="fs1rem fw600" label='Allocation Section Management' value='Allocation Section Management' />
						<Tab className="fs1rem fw600" label='Allocation Module Management' value='Allocation Module Management' />
						<Tab className="fs1rem fw600" label='Featured Business Cards' value='Featured Business Card' />
					</TabList>
					<button onClick={() => { dispatch(toggleModal({ open: 'allocationManagementLogs' })) }} className='cp tac c1 bg3 bg4-hover br5px shadow px1rem py0-5rem fw500 pa r0'>Audit Log</button>
					<TabPanel className='w100' value='Category Management'>{categoryTab()}</TabPanel>
					{/* <TabPanel className='w100' value='Section Management'>{sectionTab()}</TabPanel>
						<TabPanel className='w100' value='Module Management'>{moduleAllocationTab()}</TabPanel> */}
					<TabPanel className='w100' value='Allocation Section Management'>{allocationSectionTab()}</TabPanel>
					<TabPanel className='w100' value='Allocation Module Management'>{allocationModuleTab()}</TabPanel>
					<TabPanel className='w100' value='Featured Business Card'>
						<UserAllocationManagement
							sectionList={[...sectionList, ...expensionPackList]}
							TablePagination={TablePagination}
							rowsPerPage={rowsPerPage}
							currentPage={currentPage}
							handleChangePage={handleChangePage}
							handleChangeRowsPerPage={handleChangeRowsPerPage}
						/>
					</TabPanel>
				</TabContext>
			</div>
		);
	};

	const categoryTab = () => {
		return (
			<div className="bg1 shadow p2rem dg gg2rem">
				<div className="df fdc aic bss bw2px bo5 br10px p2rem">
					<div className="df jcsb w100">
						<h3 className="fs1-5rem fs2rem-sm ttu tac c4 df jcsb">
							Category Management
						</h3>
						<Add
							className="cp"
							onClick={() => {
								dispatch(toggleModal({ open: 'addEditCategory' }));
								setSelectedData({ title: 'Add Category' })
							}}
							title={'Add Category'}
						/>
					</div>
					<div className='admin-table mt1rem w100 ttc tac'>
						<ReactTable
							minRows={15}
							className="table"
							resolveData={categoryList => categoryList.map(row => row)}
							data={categoryList}
							columns={CATEGORY_TABLE_COLUMNS}
							filterable={true}
							defaultFilterMethod={filterCaseInsensitive}
						/>
					</div>
				</div>
			</div>
		);
	};

	// Pagination
	const handleChangePage = (event, newPage) => setCurrentPage(newPage);

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setCurrentPage(0);
	};

	const handleAssignCategory = async ({ section, category, valueAssign, type }) => {
		try {
			const response = await postRequest('/admin/assign/category/section', {
				id: section._id,
				sectionNo: section.sectionNo,
				categoryName: category.name,
				categoryId: category._id,
				allocationType: type,
				type: valueAssign
			})

			if (response['code'] === 200) {
				if (type === "section") {
					setSectionList((prev) => {
						const index = prev.findIndex((item) => item._id === section._id);

						if (index === -1) {
							return prev;
						}

						const updatedItem = { ...prev[index] };

						if (valueAssign === true) {
							updatedItem.categoryId = category._id;
						} else {
							delete updatedItem.categoryId;
						}

						return [
							...prev.slice(0, index),
							updatedItem,
							...prev.slice(index + 1),
						];
					});

				} else {
					setExpensionPackList((prev) => {
						const index = prev.findIndex(item => item._id === section._id);
						if (index === -1) {
							return prev;
						}
						const updatedItem = { ...prev[index] };
						if (valueAssign === true) {
							updatedItem.categoryId = category._id;
						} else {
							delete updatedItem.categoryId;
						}
						return [
							...prev.slice(0, index),
							updatedItem,
							...prev.slice(index + 1)
						];
					});
				}
				showMessage(response['message'])
			}

		} catch (err) {
			console.log(err, "error")
		}
	};

	const paginatedData = sectionList?.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage);

	const allocationSectionTab = () => {
		return (
			<div className="bg1 shadow p2rem dg gg2rem allocationSectionAdmin">
				<div className="df fdc aic bss bw2px bo5 br10px p2rem" >
					<h3 className="fs1-5rem fs2rem-sm ttu tac c4" >Allocation Section Management</h3>
					<p>Allocation Section Management</p>
					<div className="df aic jcfs w100">
						<input type="checkbox" checked className="mr1rem" />
						<p>Business Audit, Data Repository, 2 Minute Test</p>
					</div>
					<div className="mt2rem" style={{ overflowX: 'scroll', width: '1300px' }}>
						<table>
							<tr>
								<th>Section Name</th>
								{categoryList.map((cat_obj, car_i) => {
									return (
										<th key={car_i}>
											{cat_obj.name}
										</th>
									)
								})}
							</tr>
							<tbody>
								{paginatedData?.map((sec_obj, sec_i, sec_arr) => (
									<tr key={sec_i}>
										<td className="df fdc jcs aic">
											<Typography fontWeight={400} fontSize={'10px'}>
												{sec_obj?.sectionNo}
											</Typography>
											<Typography fontWeight={600} fontSize={'10px'}>
												{sec_obj?.sectionName}
											</Typography>
										</td>
										{categoryList.map((cat_obj, car_i, car_arr) => (
											<td key={car_i}>
												<FormControl sx={{ m: 1, width: 80 }}>
													<input
														type="checkbox"
														checked={sec_obj?.categoryId === cat_obj?._id}
														onChange={(e) => handleAssignCategory({
															section: sec_obj,
															category: cat_obj,
															valueAssign: e.target.checked,
															type: 'section'
														})} />
												</FormControl>
											</td>
										))}
									</tr>
								))}
							</tbody>
						</table>
					</div>
					<div className="w100 df jce">
						<TablePagination
							rowsPerPageOptions={[5, 10, 25]}
							component="div"
							count={sectionList?.length || 0}
							rowsPerPage={rowsPerPage}
							page={currentPage}
							onPageChange={handleChangePage}
							onRowsPerPageChange={handleChangeRowsPerPage}
						/>
					</div>
				</div>
			</div >
		);
	};

	const expensionPackData = expensionPackList?.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage);

	const allocationModuleTab = () => {
		return (
			<div className="bg1 shadow p2rem dg gg2rem allocationSectionAdmin">
				<div className="df fdc aic bss bw2px bo5 br10px p2rem" >
					<h3 className="fs1-5rem fs2rem-sm ttu tac c4" >Allocation Module Management</h3>
					<p>Allocation Module Management</p>
					<div className="mt2rem" style={{ overflowX: 'scroll', width: '1300px' }}>
						<table>
							<tr>
								<th>Module Name</th>
								{categoryList.map((cat_obj, car_i) => {
									return (
										<th key={car_i}>
											{cat_obj.name}
										</th>
									)
								})}
							</tr>
							<tbody>
								{expensionPackData?.map((sec_obj, sec_i, sec_arr) => (
									<tr key={sec_i}>
										<td className="df fdc jcs aic">
											<Typography fontWeight={400} fontSize={'10px'}>
												{sec_obj?.sectionNo}
											</Typography>
											<Typography fontWeight={600} fontSize={'10px'}>
												{sec_obj?.sectionName}
											</Typography>
										</td>
										{categoryList.map((cat_obj, car_i, car_arr) => (
											<td key={car_i}>
												<FormControl sx={{ m: 1, width: 80 }}>
													<input
														type="checkbox"
														checked={sec_obj?.categoryId === cat_obj?._id}
														onChange={(e) => handleAssignCategory({
															section: sec_obj,
															category: cat_obj,
															valueAssign: e.target.checked,
															type: 'expension'
														})} />
												</FormControl>
											</td>
										))}
									</tr>
								))}
							</tbody>
						</table>
					</div>
					<div className="w100 df jce">
						<TablePagination
							rowsPerPageOptions={[5, 10, 25]}
							component="div"
							count={expensionPackData?.length || 0}
							rowsPerPage={rowsPerPage}
							page={currentPage}
							onPageChange={handleChangePage}
							onRowsPerPageChange={handleChangeRowsPerPage}
						/>
					</div>
				</div>
			</div >
		);
	};

	const onAddEditModalClosed = () => {
		dispatch(toggleModal({ open: '' }))
		setCategory('')
		setSectionName('')
		setSectionNo('')
		setSelectedData(null)
	};

	const sortQuestions = (a, b) => {
		if (a?.['qNo'] > b?.['qNo']) return 1;
		else return -1;
	};

	const sortQuestionsByQNo = (questions) => {
		return questions.sort((a, b) => {
			const aParts = a['qNo'].match(/\d+/g)?.map(Number);
			const bParts = b['qNo'].match(/\d+/g)?.map(Number);
			for (let i = 0; i < Math.max(aParts.length, bParts.length); i++)
				if ((aParts[i] || 0) !== (bParts[i] || 0)) return (aParts[i] || 0) - (bParts[i] || 0);
			return 0;
		});
	};

	return (aiTest && tab == "Deduper") ? <AiDeduperTestComponent onBack={() => { setTab(""); setAiTest(false) }} />
		: ((aiTest && tab == "FA") ? <AiFilingAssistantTestComponent onBack={() => { setTab(""); setAiTest(false) }} />
			: ((aiTest && currentSection) ? <AiTestComponent section={currentSection} onBack={() => { setCurrentSection(null); }} />
				: (tab == "view-firms") ? <ViewFirms setSelectedFirm={setSelectedFirm} selectedFirm={selectedFirm} setTab={setTab} onBack={() => setTab("")} />
					: (tab == "add-firm" || tab.includes('edit-firm')) ? <AddEditInvestor setTab={setTab} onBack={() => { setTab(""); }} tab={tab} />
						: (tab == "TH") ? <AiTwoHundredsComponent onBack={() => { setTab(""); setAiTest(false) }} />
							: (tab == "CH") ? <AiChecklist onBack={() => { setTab(""); setAiTest(false) }} />
								// : (aiTest && currentSection) ? <AiTwoMinTestComponent section={currentSection} onBack={() => { setCurrentSection(null); }} />
								: <AnimatedPage>
									<div className="px4rem py2rem df fdc">
										{tab != 'ChatGPT-History' && tab != 'Deduper-History' && tab != 'FA-History' && tab != 'TH-History' && tab != 'CH-History' && tab != 'TM-History' && <HeadingSubheadingContent wrapperClass="mb2rem tac"
											heading={aiTest ? `Admin Panel - AI Test` : `Admin Panel`}
											subheading={aiTest ? tab : `${tab} Sections`} />}
										<div className="df fdc aic advisor-index oscx">
											{tab === '' &&
												<TabContext value={panel}>
													<TabList onChange={(e, value) => setPanel(value)}>
														<Tab className="fs1rem fw600" label='Modules' value='Modules' />
														<Tab className="fs1rem fw600" label='Companies' value='Companies' />
														<Tab className="fs1rem fw600" label='Users' value='Users' />
														<Tab className="fs1rem fw600" label='Partners' value='Partners' />
														<Tab className='fs1rem fw600' label='Investors' value='Investors' />
														<Tab className='fs1rem fw600' label='ChatGPT' value='ChatGPT' />
														<Tab className='fs1rem fw600' label='Prompts' value='ai-prompts' />
														<Tab className='fs1rem fw600' label='KPIs' value='KPIs' />
														<Tab className='fs1rem fw600' label='Audit Log' value='Audit Log' />
														<Tab className='fs1rem fw600' label='Checklist' value='Checklist Module Builder' />
														<Tab className='fs1rem fw600' label='Allocation Management' value='Allocation Management' />
														<Tab className='fs1rem fw600' label='Transaction Settings' value='Transaction Settings' />
													</TabList>
													<TabPanel className='w100' value='Modules'>{modulesTab()}</TabPanel>
													<TabPanel className='w100' value='Companies'>{companiesTab()}</TabPanel>
													<TabPanel className='w100' value='Users'>{usersTab()}</TabPanel>
													<TabPanel className='w100' value='Partners'>{partnersTab()}</TabPanel>
													<TabPanel className='w100' value='Investors'>
														<ViewFirms setSelectedFirm={setSelectedFirm} selectedFirm={selectedFirm} setTab={setTab} onBack={() => setTab("")} />
													</TabPanel>
													{/* <TabPanel className='w100' value='ChatGPT'>{chatGPTTab()}</TabPanel> */}
													<TabPanel className='w100' value='ChatGPT'><ChatGPTTab /></TabPanel>
													<TabPanel className='w100' value='ai-prompts'><AIPrompts /></TabPanel>
													<TabPanel className='w100' value='KPIs'>{kpiTab()}</TabPanel>
													<TabPanel className='w100' value='Audit Log'>{auditLogTab()}</TabPanel>
													<TabPanel className='w100' value='Checklist Module Builder'>{checklistModuleBuilder()}</TabPanel>
													<TabPanel className='w100' value='Allocation Management'>{advisorAllocationTab()}</TabPanel>
													<TabPanel className='w100' value='Transaction Settings'>
														<TransactionSettings />
													</TabPanel>
												</TabContext>
											}
										</div>
										{tab && tab != 'ChatGPT-History' && tab != 'Deduper-History' && tab != 'FA-History' && tab != 'TH-History' && tab != 'CH-History' && tab != 'TM-History' && tab != 'checklist-builder' && tab == "" && (
											<span onClick={() => { setTab(""); setAiTest(false); getQuestions(); }} className="mra shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic">
												<svg className="pen f1 h2rem mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
													<path className="fa-primary pen" d="M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z" />
													<path className="fa-secondary pen" d="M447.1 256C447.1 273.7 433.7 288 416 288H109.3l-32-32l32-32H416C433.7 224 447.1 238.3 447.1 256z" />
												</svg>
												Back to Menu
											</span>
										)}
										{tab && tabsAndKeys[tab] && sectionsAndQuestions[tabsAndKeys[tab]['name']]
											? <>
												<Link
													onClick={() => { setTab(""); getQuestions(); }} to='/admin' className="mra shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic">
													<svg className="pen f1 h2rem mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
														<path className="fa-primary pen" d="M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z" />
														<path className="fa-secondary pen" d="M447.1 256C447.1 273.7 433.7 288 416 288H109.3l-32-32l32-32H416C433.7 224 447.1 238.3 447.1 256z" />
													</svg>
													Back to Menu
												</Link>

												{sectionsAndQuestions[tabsAndKeys[tab]['name']]['sections']?.map((section, sectionIndex) => {
													const sortedQuestions = section['questions'].sort(sortQuestions);
													return <>
														{aiTest
															? <div className={(section.sectionNo ? "shadow " : "") + "mt1rem bg1 py1rem px2rem br5px cp bss bw2px bo5"} onClick={() => { setCurrentSection(section); }}>
																<h3 className="usn pen fs1-5rem fw600">{section['sectionNo']} - {section['sectionName']}</h3>
															</div>
															: <div className={(section.sectionNo ? "shadow " : "") + "mt1rem toggleHeight bg1 py1rem px2rem br5px cp bss bw2px bo5"}>
																<h3 className="usn pen fs1-5rem fw600">{section['sectionNo']} - {section['sectionName']} asd</h3>
																<div style={{ cursor: "auto", height: "0px" }} className="oh">
																	{sortedQuestions.map((question, questionIndex) => (
																		<div key={question._id} data-id={question._id} className="dg gg1rem mx1rem p1rem py0-5rem my0-5rem bss bw2px bo5 br10px">
																			<h3 className="usn pen fs1-25rem fw600">Question No: {question['qNo']}</h3>
																			{(() => {
																				let maxRisk = 5;
																				let minRisk = -5;
																				let questionKeys = getQuestionKeys(question);
																				let riskKeys = questionKeys.filter(k => k.startsWith("riskIf"));
																				return <>
																					{questionKeys.filter(k => !k.startsWith("riskIf")).map((key, idx) => {
																						let placeholder = key.replace(/^q/, "").replace(/([A-Z])/g, " $1").replace(/^./, s => s.toUpperCase());
																						return key == "templateFiles"
																							? <Fragment key={idx}>
																								<label onDragOver={onDragOver} onDrop={(e) => onDrop(e, question, sectionIndex, questionIndex, tabsAndKeys[tab]['name'])} for={"fileUpload" + question._id} className="w100 bsbb bg5 br5px df jcc aic px2rem py5rem bsd bo6 bw2px cp mb0-5rem">
																									<span className="pen fs1rem fw500 tac">Click here or drag and drop template files (max 100MB)</span>
																									<input onChange={(e) => saveQuestion(e, question, sectionIndex, questionIndex, tabsAndKeys[tab]['name'])} className="dn" id={"fileUpload" + question._id} type="file" multiple />
																								</label>
																								<div className="df fww">
																									{question['templateFiles'] && question['templateFiles'].map(file => <Link key={file['originalname'] + file['etag']} className="df jcc aic br25px lh1 bg3 c1 px0-5rem fw600 mr0-5rem mb0-5rem" target="_blank" to={file['location']}>
																										<span className="py0-5rem pl0-5rem">{file['originalname']}</span>
																										<svg onClick={e => { e.preventDefault(); setDeleteFileQuestionId(question['_id']); setDeleteFile(file); dispatch(toggleModal({ open: 'deleteFile' })) }} className="p0-5rem f9 w1rem h1rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
																											<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
																										</svg>
																									</Link>)}
																								</div>
																							</Fragment>
																							: <div className="pr">
																								{inputValues[key]?.['title'] && <label className='fw500'>{inputValues[key]?.['title']}</label>}
																								<textarea onBlur={(e) => saveQuestion(e, question, sectionIndex, questionIndex, tabsAndKeys[tab]['name'])} defaultValue={question[key]} name={key} type="text" placeholder={inputValues[key]?.['placeholder'] || placeholder} className="bss bw2px bo5 pl4rem pt1rem bg1 w100 br5px" />
																								<div data-tooltip={inputValues[key]?.['placeholder'] || placeholder}>{inputValues[key]['icon']}</div>
																							</div>
																					})}
																					{riskKeys.length > 0 &&
																						<>
																							<b className="w100 tac fs1-25rem">Assign Risk Scores</b>
																							<div className="riskSlider bsbb pr w100 tac">
																								{riskKeys.map((key, idx) => <input key={idx} data-id={key} name={key} onChange={(e) => saveQuestion(e, question, sectionIndex, questionIndex, tabsAndKeys[tab]['name'])} type="range" className={key + " pen pa oyv l0 w100"} min={minRisk} max={maxRisk} defaultValue={question[key]} />)}
																							</div>
																							<div className="df jcsb w100">
																								{Array(Math.abs(minRisk) + Math.abs(maxRisk) + 1).fill(1).map((j, i) => <span key={i} className="w1rem tac">{minRisk + i}</span>)}
																							</div>
																							<div className="df jcsb w100">
																								<b>Low Risk</b>
																								<b>High Risk</b>
																							</div>
																						</>
																					}
																				</>;
																			})()}
																		</div>
																	))}
																</div>
															</div>
														}</>
												})
												}
											</>
											: tab == 'ChatGPT-History' ? <AiHistoryComponent onBack={() => { setTab(""); setAiTest(false); getQuestions(); }} />
												: (tab == 'Deduper-History' ? <AiDeduperHistoryComponent onBack={() => { setTab(""); setAiTest(false); }} />
													: (tab == 'FA-History' ? <AiFilingAssistantHistoryComponent onBack={() => { setTab(""); setAiTest(false); }} />
														: (tab == 'TH-History' ? <AiTwoHundredsHistoryComponent onBack={() => { setTab(""); setAiTest(false); }} />
															: (tab == 'CH-History' ? <AiChecklistHistory onBack={() => { setTab(""); setAiTest(false); }} />
																: (tab == 'TM-History' ? <AiTwoMinTestHistoryComponent onBack={() => { setTab(""); setAiTest(false); }} />
																	: (tab === 'Checklist builder' ? <ChecklistBuilderComponent
																		onEdit={false}
																		onBack={() => setTab("")}
																	/> : (tab && tab !== "" ? <ChecklistBuilderComponent
																		onEdit={true}
																		selectedModule={tab}
																		onBack={() => setTab("")}
																	/> : null))
																)
															)
														)
													)
												)
										}
									</div>
									{/* Partner Popup */}
									<Modal open={modal["open"] == "partnerPopup"} onClose={() => dispatch(toggleModal({ open: "" }))} className="backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic">
										<div className="mah70 bg1 shadow w100  bsbb df fdc m1rem maw600px br10px">
											<div className='top-header py1rem px2rem df jcsb aic bg3' style={{ background: '#4a67ff94', borderRadius: '8px 8px 0 0' }}>
												<h4 className='fs1rem c15 fw500 ttc'>{action} Partner</h4>
												<img className="w40px" src={require(`../../../../images/logo-icon.svg`)} alt="TODO" />
											</div>
											<div className="df fdc gg1rem px3rem py2rem mah500px oya advisor-box-content">
												{action == 'delete'
													? <div class='df jcc my2rem'>
														<p class='fs1rem c15'>Are you sure you want to delete partner <b>({partner['name']})</b>?</p>
													</div>
													: <div className='advisor-modal-form'>
														<div className="mb1rem">
															<label class='fw500 fsi c6 ml0-5rem' style={{ fontSize: '18px' }}>Name *</label>
															<input
																type="text"
																name="name"
																placeholder="Please enter the name"
																onChange={(e) => setPartner({ ...partner, name: e.target.value })}
																value={partner["name"]}
																className="bg1 w100 br10px px1rem py0-5rem bss bo16 bw1px c15 fs1rem mt0-5rem"
															/>
														</div>
														{action == 'create' &&
															<div className="mb1rem">
																<label class='fw500 fsi c6 ml0-5rem' style={{ fontSize: '18px' }}>Type *</label>
																<select name="type" onChange={(e) => setPartner({ ...partner, type: e.target.value })} className="bg1 w100 br10px px1rem py0-5rem bss bo16 bw1px c15 fs1rem mt0-5rem">
																	{['Business for Funding', 'Business for Sale', 'Cyber DueDil', 'Business is Investment Ready', 'Super Flow'].map(item => {
																		return <option value={item}>{item}</option>
																	})}
																</select>
															</div>
														}
														<div className="mb1rem">
															<label class='fw500 fsi c6 ml0-5rem' style={{ fontSize: '18px' }}>Company Type *</label>
															<select name="testType" onChange={(e) => setPartner({ ...partner, testType: e.target.value })} className="bg1 w100 br10px px1rem py0-5rem bss bo16 bw1px c15 fs1rem mt0-5rem">
																<option value={partner['testType']} selected disabled hidden>{partner['testType']}</option>
																{['investment', 'growth', 'exit'].map(item => {
																	return <option value={item}>{item}</option>
																})}
															</select>
														</div>
														<div className="mb1rem">
															<label class='fw500 fsi c6 ml0-5rem' style={{ fontSize: '18px' }}>Module Name</label>
															<input
																type="text"
																name="moduleName"
																placeholder="Please enter the module name"
																onChange={(e) => setPartner({ ...partner, moduleName: e.target.value })}
																value={partner["moduleName"]}
																className="bg1 w100 br10px px1rem py0-5rem bss bo16 bw1px c15 fs1rem mt0-5rem"
															/>
														</div>
														<div className="mb1rem">
															<label class='fw500 fsi c6 ml0-5rem' style={{ fontSize: '18px' }}>Module Key</label>
															<input
																type="text"
																name="moduleKey"
																placeholder="Please enter the module key"
																onChange={(e) => setPartner({ ...partner, moduleKey: e.target.value })}
																value={partner["moduleKey"]}
																className="bg1 w100 br10px px1rem py0-5rem bss bo16 bw1px c15 fs1rem mt0-5rem"
															/>
														</div>
														<div className="mb1rem">
															<label class='fw500 fsi c6 ml0-5rem' style={{ fontSize: '18px' }}>Module Description</label>
															<input
																type="text"
																name="moduleDescription"
																placeholder="Please enter the module description"
																onChange={(e) => setPartner({ ...partner, moduleDescription: e.target.value })}
																value={partner["moduleDescription"]}
																className="bg1 w100 br10px px1rem py0-5rem bss bo16 bw1px c15 fs1rem mt0-5rem"
															/>
														</div>
														<div className="mb1rem">
															<label class='fw500 fsi c6' style={{ fontSize: '18px' }}>Focus of Area:</label>
															<div class='px1rem mt0-5rem'>
																{['first', 'second', 'third'].map((item, idx) => {
																	return <div className='pr'>
																		<label className='c15 db w100'>{idx + 1} - Area of focus</label>
																		<input
																			type="text"
																			name={`focus${idx + 1}`}
																			onChange={(e) => handleAreaFocus(e)}
																			placeholder={`Write your ${item} objective focus in your own words`}
																			value={partner['focusArea']?.[`focus${idx + 1}`] || ''}
																			className="bg1 w100 br10px px1rem py0-5rem bss bo16 bw1px c15 fs1rem mt0-5rem"
																		/>
																	</div>
																})}
															</div>
														</div>
													</div>
												}
												<span onClick={() => handleSubmitPartner()} style={{ padding: '7px' }} className="new-shadow df jcc bg4 bg3-hover c1 td250 br30px fw500 cp ttu bsbb w200px">{action}</span>
												<span onClick={() => dispatch(toggleModal({ open: "" }))} className="c3-hover td250 fs1rem cp">Cancel</span>
											</div>
											<svg className="pa cp" onClick={() => dispatch(toggleModal({ open: "" }))} style={{ left: '50%', transform: 'translateX(-50%)', bottom: '40px' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
												<path d="M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z" fill="white" />
											</svg>
										</div>
									</Modal>

									{/* Partner Activation Popup */}
									<Modal open={modal["open"] == "partnerActivationPopup"} onClose={() => dispatch(toggleModal({ open: "" }))} className="backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic">
										<div className="mah70 bg1 shadow w100  bsbb df fdc m1rem maw600px br10px">
											<div className='top-header py1rem px2rem df jcsb aic bg3' style={{ background: '#4a67ff94', borderRadius: '8px 8px 0 0' }}>
												<h4 className='fs1-5rem c15 fw500 ttc'>{action} Partner</h4>
												<img className="w60px" src={require(`../../../../images/logo-icon.svg`)} alt="TODO" />
											</div>
											<div className="df fdc gg1rem px3rem py2rem mah500px oya advisor-box-content">
												<div class='df jcc my2rem'>
													<p class='fs1rem c15'>Do you want to <b>{partner['isActive'] ? 'Deactivate' : 'Activate'}</b> partner?</p>
												</div>
												<span onClick={() => handleSubmitPartner()} style={{ padding: '7px' }} className="new-shadow df jcc bg4 bg3-hover c1 td250 br30px fw500 cp ttu bsbb w200px">{partner['isActive'] ? 'Deactivate' : 'Activate'}</span>
												<span onClick={() => dispatch(toggleModal({ open: "" }))} className="c3-hover td250 fs1rem cp">Cancel</span>
											</div>
											<svg className="pa cp" onClick={() => dispatch(toggleModal({ open: "" }))} style={{ left: '50%', transform: 'translateX(-50%)', bottom: '40px' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
												<path d="M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z" fill="white" />
											</svg>
										</div>
									</Modal>

									{/* Delete File */}
									<Modal open={modal['open'] == 'deleteFile'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic">
										<div className="mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px br5px pr">
											<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
												<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
													<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
												</svg>
											</button>
											<h1 className="text-gradient fs3rem fw600">Delete File</h1>
											<h2 className="c4 fs1rem fs1-5rem-sm ttu w100 tac mb1rem">Are you sure you want to delete this file?</h2>
											<p className="fs1-25rem fw500 mb1rem">{deleteFile && deleteFile.originalname}</p>
											<span onClick={() => confirmDeleteFile()} className="shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac mb1rem df jcc aic">Delete File</span>
											<span onClick={() => dispatch(toggleModal({ open: '' }))} className="c3-hover td250 fs1-25rem cp">Cancel</span>
										</div>
									</Modal>

									{/* Delete Company */}
									<Modal open={modal['open'] == 'deleteCompanyPopup'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic">
										<div className="mah90 oya bg1 shadow w100 px2rem py3rem bsbb df fdc m1rem maw700px br5px pr">
											<img className="h2rem pa t0 center-horizontally" src={require(`../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
											<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
												<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
													<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
												</svg>
											</button>
											<h1 className="text-gradient fs2rem fw600 tac ttu mb1rem pb1rem">Delete Company </h1>
											<div className="df fdc gg1rem px2rem">

												<p className="my1rem">Are you sure you want to delete the company (<span className="fw500">{deleteCompany?.['cName']}</span>)?</p>

												<span onClick={() => submitDeleteCompany(deleteCompany?.['_id'])} className="shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac df jcc aic">Delete</span>
												<span onClick={() => dispatch(toggleModal({ open: '' }))} className="c3-hover td250 fs1-25rem cp">Cancel</span>
											</div>
										</div>
									</Modal>

									{/* Delete Company */}
									<Modal open={modal['open'] == 'deleteUserPopup'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic">
										<div className="mah90 oya bg1 shadow w100 px2rem py3rem bsbb df fdc m1rem maw700px br5px pr">
											<img className="h2rem pa t0 center-horizontally" src={require(`../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
											<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
												<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
													<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
												</svg>
											</button>
											<h1 className="text-gradient fs2rem fw600 tac ttu mb1rem pb1rem">Delete User </h1>
											<div className="df fdc gg1rem px2rem">

												<p className="my1rem">Are you sure you want to delete the user (<span className="fw500">{deleteUser?.['email']}</span>)?</p>

												<span onClick={() => submitDeleteUser(deleteUser?.['_id'])} className="shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac df jcc aic">Delete</span>
												<span onClick={() => dispatch(toggleModal({ open: '' }))} className="c3-hover td250 fs1-25rem cp">Cancel</span>
											</div>
										</div>
									</Modal>

									{/* Delete Company Logs */}
									<Modal open={modal['open'] == 'deletedCompaniesLogs'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
										<div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr">
											<img className="h2rem pa t0 center-horizontally" src={require(`../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
											<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
												<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
													<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
												</svg>
											</button>
											<h1 className="text-gradient fs1-5rem fw600 tac">Deleted Companies Logs</h1>
											<h2 className="c4 fs0-75rem ttu w100 tac mb1rem">See the history of Deleted Companies</h2>
											<div className="ma oya dg gg0-5rem mb2rem w100">
												{deletedCompaniesLogs && deletedCompaniesLogs.length > 0
													? deletedCompaniesLogs.map(log => {
														return (
															<div className="df my0-5rem">
																{log?.['userId']?.['profile']
																	&& <img className={`ass ml0-5rem br100 w2rem h2rem client-profile`} src={log['userId']['profile']} data-tooltip={log?.['userId']?.['name'] ? log?.['userId']?.['name'] : `${log?.['userId']?.['firstName']} ${log?.['userId']?.['lastName']}`} />
																	|| <span className={`ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-75rem client-profile`} data-tooltip={log?.['userId']?.['name'] ? log?.['userId']?.['name'] : `${log?.['userId']?.['firstName']} ${log?.['userId']?.['lastName']}`}>{log?.['userId']?.['name'] ? `${(log?.['userId']?.['name']?.split(' '))?.[0]?.[0] || '?'}${(log?.['userId']?.['name']?.split(' '))?.[1]?.[0] || '?'}` : `${log?.['userId']?.['firstName']?.[0] || '?'}${log?.['userId']?.['lastName']?.[0] || '?'}`}</span>
																}
																<div className="w100">
																	<span className='fs0-75rem ml1rem'><b>{log['message']}</b> at <b>{new Date(log.timestamp).toLocaleString()}</b></span>
																	<div className="shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem">
																		<p><b>Company:</b> {log?.['payload']?.['companyName']}</p>
																		<p><b>Owner Name:</b> {log?.['payload']?.['creatorName']}</p>
																		<p><b>Owner Email:</b> {log?.['payload']?.['creatorEmail']}</p>
																	</div>
																</div>
															</div>
														)
													})
													: <h2 className="c4 fs1-50rem ttu w100 tac mb1rem">No Logs Found!</h2>
												}
											</div>
										</div>
									</Modal>

									{/* Remove Module */}
									<Modal id='confirmLogoutPopUp' open={modal['open'] === 'confirmDeleteModule'} onClose={() => dispatch(toggleModal({ open: '' }))} className='backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic'>
										<div className='mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr'>
											<button className='close-popup' onClick={() => dispatch(toggleModal({ open: '' }))}>
												<svg style={{ position: 'relative', top: '4px' }} className='pen fds h1rem f1 mr0-5rem' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'>
													<path
														className='pen fa-primary'
														d='M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z'
													/>
												</svg>
											</button>
											<h1 className='text-gradient fs2rem tac lh1 fw600 mb2rem'>
												Confirmation
											</h1>
											{/* <p className='text-gradient fs2rem tac lh1 fw600 mb2rem'> */}
											<div className='logoutConfirmModal'>Are you sure you want to delete this module?</div>
											{/* </p> */}
											<div className='df jcsb gg1rem'>
												<span
													onClick={() => dispatch(toggleModal({ open: '' }))}
													className='shadow bo4 bss bg1 bg4-hover c4 c1-hover td250 br5px p1rem fw600 cp w30 ttu  bsbb tac mb1rem df jcc aic'
												>
													Cancel
												</span>
												<span
													onClick={() => { deleteModule(deleteModuleName); dispatch(toggleModal({ open: '' })) }}
													className='shadow bg3 bo3 bss bo4-hover bg4-hover c1 td250 br5px p1rem fw600 w50 cp ttu  bsbb tac mb1rem df jcc aic'
												>
													Confirm
												</span>
											</div>
										</div>
									</Modal>

									{/* Create and Edit Category Modal */}
									<CreateCategory
										modal={modal}
										selectedData={selectedData}
										dispatch={dispatch}
										toggleModal={toggleModal}
										categoryList={categoryList}
										getCategorys={getCategorys}
									/>

									{/* Delete confirmation Category Modal */}
									<DeleteCategory
										modal={modal}
										selectedData={selectedData}
										dispatch={dispatch}
										toggleModal={toggleModal}
										getCategorys={getCategorys}
									/>

									{/* Create and Edit Section Modal */}
									<CreateEditSection
										modal={modal}
										selectedData={selectedData}
										dispatch={dispatch}
										toggleModal={toggleModal}
										sectionList={sectionList}
										getCategorys={getCategorys}
									/>

									{/* Delete confirmation Category Modal */}
									{/* <DeleteSection
										modal={modal}
										selectedData={selectedData}
										dispatch={dispatch}
										toggleModal={toggleModal}
										getCategorys={getCategorys}
									/> */}

									<CategoryLogsModal
										subPanel={subPanel}
										modal={modal}
										toggleModal={toggleModal}
										dispatch={dispatch}
									/>

								</AnimatedPage >
			)
		)
}
